export const environment = {
  production: true,
  apiUrl: '',
  apiVersion: '2',
};
